import React from 'react';
import './CourseView.less';
import LectureList from '../../lecture/LectureList/LectureList.jsx';
import CourseCompletion from '../../course/CourseCompletion/CourseCompletion.jsx';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router';

type Props = {
  courseStore: Object,
  lectureStore: Object,
  params: Object,
  router: Object
}

const strings = {
  overview: 'Course Overview',
  curriculum: 'Curriculum',
  loading: 'Loading'
};
const CourseView = observer(['courses'], withRouter(({courses, params}) => {
  const courseId = params.courseId;
  courses.loadId(courseId);
  const course = courses.courses.get(courseId);
  switch (course.status) {
    case 404:
      this.props.router.push('/404');
      return null;
    case 200:
      return (
        <div className="course-view bloc-small m-t-xl">
          <h1 className="text-center">{ course.name }</h1>
          <div className="m-t-xl">
            <img alt={ course.name } src={ course.cover } />
          </div>
          <div className="m-t-xl m-b-xl">
            <CourseCompletion courseId={ courseId } />
          </div>
          <hr className="m-t-xl m-b-xl" />
          <div>
            <h2 className="text-center">{ strings.overview }</h2>
            <p className="m-t-xl">{ course.description }</p>
          </div>
          <hr className="m-t-xl m-b-xl" />
          <div className="m-t-xl">
            <h2 className="text-center">{ strings.curriculum }</h2>
            <LectureList courseId={ courseId } />
          </div>
        </div>
      );
    default:
      return null;
  }
}));

export default CourseView;

//Unit test entry point
export const CourseViewTest = CourseView;


/** WEBPACK FOOTER **
 ** ./src/js/views/CourseView/CourseView.jsx
 **/